import { ref } from 'vue'
import {speaker} from '@stream'

export default function useSpeaker () {
  const isPlaying = ref(false)
  const play = async (sound) => {
    isPlaying.value = true
    await speaker.play(sound)
    isPlaying.value = false
  }

  const change = async (deviceId, deviceLabel) => {
    await speaker.change(deviceId, deviceLabel)
  }

  return {
    change,
    play,
    isPlaying
  }
}
